// import { createSharedPathnamesNavigation } from 'next-intl/navigation';
// import { LOCALES } from 'src/envVariables';
// const {
//   Link: NextLink,
//   useRouter,
//   usePathname,
// } = createSharedPathnamesNavigation({
//   locales: LOCALES,
//   localePrefix: 'as-needed',
// });
import { createNavigation } from 'next-intl/navigation';
import { routing } from 'root/src/i18n/routing';

// Lightweight wrappers around Next.js' navigation APIs
// that will consider the routing configuration
export const {
  Link: NextLink,
  usePathname,
  useRouter,
} = createNavigation(routing);
